<template>
  <div>
    <p>Traduction demandée.</p>
    <p>Devis accepté.</p>
    <hr/>
    <div class="field">
      <label class="label">Traduction</label>
      <div class="control">
        <textarea
            class="textarea"
            v-model="context.data.text_native"
            :disabled="!context.active"
        ></textarea>
      </div>
    </div>
    <a
        class="button is-pulled-right is-primary is-small"
        @click="save_answer()"
        :disabled="!context.active || context.data.text_native === ''"
    >
      Enregistrer
    </a>
    <br/>
  </div>
</template>


<script>
export default {
  name: "StateTranslationNeeded",
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  methods: {
    save_answer() {
      this.$emit("state:update_data", this.context.data);
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
